/**
 * Press feel for every single pad (DEC-317 / DEC-321, built 2026-10-27): the pad sinks under the finger and light spreads
 * from where it was touched. The button grid does its own (ButtonGrid.tsx); every other pad shares the `.midi-button`
 * face, so ONE delegated listener covers them all (FireButton, Helix preset and snapshot tiles, Rig State buttons,
 * OPVisual triggers, the light buttons) without touching each component.
 *
 * Visual only: it never stops, delays or reorders the press the component itself handles. Off in edit mode, where a
 * press selects or drags, and on a disabled pad.
 */

import { isEditMode } from './store.ts';

let installed = false;

function release(e: Event): void {
  const pad = (e.target as Element | null)?.closest?.('.midi-button[data-press]');
  if (pad) (pad as HTMLElement).removeAttribute('data-press');
  for (const p of Array.from(document.querySelectorAll<HTMLElement>('.midi-button[data-press]'))) p.removeAttribute('data-press');
}

function down(e: PointerEvent): void {
  if (isEditMode()) return;
  const pad = (e.target as Element | null)?.closest?.('.editable-item .midi-button') as HTMLElement | null;
  if (!pad || (pad as HTMLButtonElement).disabled || pad.dataset.disabled === 'true') return;
  pad.dataset.press = 'true';
  const r = pad.getBoundingClientRect();
  if (r.width === 0) return;
  let rc = pad.querySelector<HTMLElement>(':scope > .pad-rc');
  if (!rc) {
    rc = document.createElement('span');
    rc.className = 'pad-rc';
    rc.setAttribute('aria-hidden', 'true');
    pad.appendChild(rc);
  }
  const rp = document.createElement('i');
  rp.className = 'bg-cell-rip';
  rp.style.left = `${(((e.clientX - r.left) / r.width) * 100).toFixed(1)}%`;
  rp.style.top = `${(((e.clientY - r.top) / r.height) * 100).toFixed(1)}%`;
  rc.appendChild(rp);
  window.setTimeout(() => rp.remove(), 700);
}

/** Once, from App.tsx. Capture phase, passive: it watches the press, it never handles it. */
export function installPressFeel(): void {
  if (installed) return;
  installed = true;
  document.addEventListener('pointerdown', down, { capture: true, passive: true });
  document.addEventListener('pointerup', release, { capture: true, passive: true });
  document.addEventListener('pointercancel', release, { capture: true, passive: true });
}
